import type { ColSize } from 'antd/es/grid/col'

export const USER_CONTROL_COL = {
  segmented: { flex: '0 0 10rem' },
  select: { flex: '0 0 13rem' },
  dateRange: { flex: '0 0 16rem' },
} satisfies Record<string, ColSize>
